export const GET_SINGLE_TEMPLATE = 'GET_SINGLE_TEMPLATE'
export const GET_ALL_TEMPLATES = 'GET_ALL_TEMPLATES'
export const GET_ALL_STATIC_PAGES = 'GET_ALL_STATIC_PAGES'
export const GET_SINGLE_STATIC_PAGE = 'GET_SINGLE_STATIC_PAGE'
export const GET_ALL_FOOTER_LINKS = 'GET_ALL_FOOTER_LINKS'
export const GET_SINGLE_FOOTER_LINK = 'GET_SINGLE_FOOTER_LINK'
export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
